import type { IViewDataInitialState } from 'src/redux/viewData/types';

export const commentRequest = (
  state: IViewDataInitialState,
): IViewDataInitialState => ({
  ...state,
  COMMENTS_LIST: {
    ...state.COMMENTS_LIST,
    isFetching: true,
  },
});
